import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import QuickContactForm from "./components/QuickContactForm";
import AboutSection from "./components/AboutSection";
import LayoutsSection from "./components/LayoutsSection";
import AmenitiesSection from "./components/AmenitiesSection";
import QualitySection from "./components/PrivacySection";
import InvestmentSection from "./components/InvestmentSection";
import LocationSection from "./components/LocationSection";
import GallerySection from "./components/GallerySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLeads from "./pages/AdminLeads";
import ProtectedRoute from "./components/ProtectedRoute";

// Landing Page Component
const LandingPage = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <QuickContactForm />
      <AboutSection />
      <LayoutsSection />
      <AmenitiesSection />
      <QualitySection />
      <InvestmentSection />
      <LocationSection />
      <GallerySection />
      <ContactSection />
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Protected Admin Routes */}
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/admin/leads" 
              element={
                <ProtectedRoute>
                  <AdminLeads />
                </ProtectedRoute>
              } 
            />
            
            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;